import React from "react";
import { Modal } from "react-bootstrap";
import "cropperjs/dist/cropper.css";
import { useDispatch } from "react-redux";
import { closeOptionalInfoModel } from "../../store/slices/contestSlice";
import { closeOptionalInfoModelPoll } from "../../store/slices/pollSlice";
import { useSelector } from "react-redux";

const OptionalInfoModel = ({ heading, show, isPolls = false }) => {
    const dispatch = useDispatch();
    const hideModel = () => isPolls ? dispatch(closeOptionalInfoModelPoll()) : dispatch(closeOptionalInfoModel());
    const { optonalInfo } = useSelector((state) => isPolls ? state.poll : state.contest);
    return (
        <Modal show={show} size="lg" onHide={hideModel} centered backdrop="static" keyboard={false} >
            <div>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{heading}</h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={hideModel}
                        ></button>
                    </div>
                    <div className="modal-body w-100">
                        <div className="media-content">
                        {optonalInfo?.image && (<div className="text-center mb-4">
                                <img
                                    src={optonalInfo?.image?.trim()}
                                    className="img-fluid rounded"
                                    alt="Contest visual"
                                    style={{
                                        maxHeight: '400px',
                                        objectFit: 'contain'
                                    }}
                                    onError={(e) => {
                                        e.target.style.display = 'none';
                                    }}
                                />
                            </div>)}

                            {optonalInfo?.description && (<div className="description-section">
                                <h6 className="mb-3">Description:</h6>
                                <div
                                    className="contest-description p-3 rounded border"
                                    style={{
                                        backgroundColor: '#f8f9fa',
                                        fontSize: '14px',
                                        lineHeight: '1.6',
                                        maxHeight: '400px',
                                        overflow: 'auto'
                                    }}
                                    dangerouslySetInnerHTML={{ __html: optonalInfo?.description?.trim() }}
                                />
                            </div>)}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={hideModel}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default OptionalInfoModel;